import File from "../../../assets/dashboard/file-shield.svg";
import Mail from "../../../assets/dashboard/mail.svg";
import ArrowDown from "../../../assets/dashboard/arrow-circle-broken-down.svg";

const cardData = [
  {
    name: "Active Engagements",
    value: "20",
    icon: File,
  },
  {
    name: "Active Tasks",
    value: "50",
    icon: Mail,
  },
  {
    name: "Completed Tasks",
    value: "02",
    icon: ArrowDown,
  },
];

export default cardData;
